
import Vue from 'vue';
import _ from 'lodash';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  data() {
    return {
      selectedOptions: []
    }
  },
  computed: {
    checkboxGroupItems: function(): { itemText: string, itemValue: string }[] {
      let inputItems = [];
      try {
        inputItems = JSON.parse(this.input.items) || [];
      } catch (error) {
        const variableValue = this.getVariable(this.input.items);
        if(variableValue) {
          inputItems = Array.isArray(variableValue) ? variableValue : Object.values(variableValue);
        }
      }
      let checkboxGroupItems: { itemText: string, itemValue: string }[] = [];
      if(this.input.itemText && this.input.itemValue) {
        checkboxGroupItems = inputItems.map((currentItem: any) => {
          return {
            itemText: _.get(currentItem, this.input.itemText),
            itemValue: _.get(currentItem, this.input.itemValue),
          }
        })
      } else {
        checkboxGroupItems = inputItems.map((currentItem: string) => {
          return { itemText: currentItem, itemValue: currentItem }
        });
      }
      return checkboxGroupItems;
    }
  },
  watch: {
    selectedOptions: function(value: any[]) {
      const { prefix: prefix1, key: key1 } = this.parent._getPrefixAndKey(this.input.variable);
      const initialData = this.getVariable(prefix1);
      const { prefix, key } = this.parent._getPrefixAndKey(prefix1);
      this.$set(this.getVariable(prefix), key, { ...initialData, [key1]: value || [] });
    } 
  },
  mounted() {
    this.$watch(
      () => this.parent._getVariable(this.input.variable), 
      async (selectedValues) => {
        this.selectedOptions = selectedValues
      },
      { immediate: true }
    )
  }
})
